import { parsePath, type Segment } from '../geometry/path';
import { DOCUMENT_LIMITS } from '../model/types';

/**
 * Content-addressed cache of parsed path data. Keys are the exact `d` strings, so
 * entries can never go stale; eviction is least-recently-used within a fixed budget.
 * Callers must treat returned arrays as immutable.
 */
const MAX_ENTRIES = 20_000;
const cache = new Map<string, readonly Segment[]>();

export function parsePathCached(d: string): readonly Segment[] {
  const hit = cache.get(d);
  if (hit) {
    cache.delete(d);
    cache.set(d, hit);
    return hit;
  }
  const segments = Object.freeze(parsePath(d, { maxCommands: DOCUMENT_LIMITS.maxPathCommands }));
  cache.set(d, segments);
  if (cache.size > MAX_ENTRIES) {
    const oldest = cache.keys().next().value;
    if (oldest !== undefined) cache.delete(oldest);
  }
  return segments;
}

export function clearParseCache(): void {
  cache.clear();
}
